import script from "./AppNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotification.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotification.vue?vue&type=style&index=0&id=f08befa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f08befa0"]])

export default __exports__